module.exports = __webpack_public_path__ + "img/selfie_ci.edd8acab.png";